// Status vocab for Quotation - passed as classMap/labelMap overrides into
// the shared components/common/StatusBadge, same convention as
// salesStatusMaps.js's ENQUIRY_STATUS_CLASS/LABEL.
export const QUOTATION_STATUS_CLASS = {
  SUBMITTED: "badge-linewarning",
  APPROVED: "badge-linesuccess",
  REJECTED: "badge-linedanger",
  CANCELLED: "badge-linedanger",
};
export const QUOTATION_STATUS_LABEL = {
  SUBMITTED: "Submitted",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled",
};

export const DELIVERY_STATUS_CLASS = {
  PENDING: "badge-linewarning",
  SENT: "badge-linesuccess",
  FAILED: "badge-linedanger",
  SKIPPED: "badge-linesecondary",
};
export const DELIVERY_STATUS_LABEL = {
  PENDING: "Pending",
  SENT: "Sent",
  FAILED: "Failed",
  SKIPPED: "Skipped",
};
